import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Falha ao importar um pedaço do app que o deploy já apagou.
 *
 * Cada build renomeia os arquivos por hash. Quem está com a página aberta
 * durante o deploy pede o arquivo antigo, recebe 404 e o navegador lança
 * "Importing a module script failed" (Safari), "Failed to fetch dynamically
 * imported module" (Chrome) ou "error loading dynamically imported module"
 * (Firefox). Recarregar busca o build novo.
 */
const FALHA_DE_CARREGAMENTO = /Importing a module script failed|Failed to fetch dynamically imported module|error loading dynamically imported module|ChunkLoadError/i;

/** Uma recarga por janela: se o build novo também falhar, o erro aparece em vez de recarregar sem fim. */
export const CHAVE_DA_RECARGA = 'mg.recarga-apos-deploy';
const JANELA_MS = 30_000;

export function ehFalhaDeCarregamento(erro: unknown): boolean {
  const texto = erro instanceof Error ? `${erro.name} ${erro.message}` : String((erro as { message?: unknown })?.message ?? erro);
  return FALHA_DE_CARREGAMENTO.test(texto);
}

@Injectable()
export class RecargaAposDeployErrorHandler extends ErrorHandler {
  /** Separado para o teste trocar; `location.reload` não é substituível no jsdom. */
  recarregar: () => void = () => window.location.reload();

  override handleError(erro: unknown): void {
    const causa = (erro as { rejection?: unknown })?.rejection ?? erro;
    if (ehFalhaDeCarregamento(causa) && this.podeRecarregar()) {
      this.recarregar();
      return;
    }
    super.handleError(erro);
  }

  private podeRecarregar(): boolean {
    try {
      const ultima = Number(sessionStorage.getItem(CHAVE_DA_RECARGA) ?? 0);
      if (Date.now() - ultima < JANELA_MS) return false;
      sessionStorage.setItem(CHAVE_DA_RECARGA, String(Date.now()));
      return true;
    } catch {
      return false;
    }
  }
}
